import {gql} from "@apollo/client";

export const completeKycOriginationMutation = gql`
mutation CompleteKycManual($customerId: String!) {
  completeKycManual: completeKycManual_Admin(customerId: $customerId)
}
`